import * as React from 'react';
export var EMPTY_PAGE_CONTEXT = {
  id: '',
  name: '',
  slug: '',
  path: '',
  entityTypeName: 'Page',
  openGraph: {
    id: '',
    title: '',
    author: '',
    image: {
      id: '',
      url: ''
    },
    description: {
      plain: ''
    }
  },
  theme: ''
};
export var PageContext = React.createContext(EMPTY_PAGE_CONTEXT);
export var PageProvider = PageContext.Provider;